import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import "rxjs/add/operator/filter";
import {HttpClient} from "@angular/common/http";
import {Conf} from "../settings/config";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LoginComponent} from "../dialogs/login/login.component";
import {User} from "../models/user.model";
import {AuthServices} from "../services/auth.service";
import {SignupComponent} from "../dialogs/signup/signup.component";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

    public bar_tab = 'visitors';

    auth_user = new User();
    reset_key;
    menu = [];
    meeting_menu = [];
    home = true;


    constructor(private router: Router, private authService: AuthServices, private modalService: NgbModal, private route: ActivatedRoute, private http: HttpClient) {
        router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe((event: NavigationEnd) => {
                var url = event.url;
                if (url == '/') {
                    this.home = true;
                } else {
                    this.home = false;
                }
                if (url.indexOf("meetings") >= 0) {
                    this.bar_tab = 'meetings';
                } else if (url.indexOf("trade-and-press") >= 0) {
                    this.bar_tab = 'trade-and-press';
                } else if (url.indexOf('about-us') >= 0) {
                    this.bar_tab = 'about-us';
                } else {
                    this.bar_tab = 'visitors';
                }

                if (url.indexOf("#") < 0) {
                    window.scrollTo(0, 0);
                }
            });
    }

    eventFire(el, etype) {
        if (el.fireEvent) {
            el.fireEvent('on' + etype);
        } else {
            var evObj = document.createEvent('Events');
            evObj.initEvent(etype, true, false);
            el.dispatchEvent(evObj);
        }
    }

    ngOnInit() {
        this.authService.currentUser.subscribe((user: User) => {
            this.auth_user = user;
        });
        this.authService.getAuthUser();

        let this_h = this;

        this.route
            .queryParams
            .subscribe(params => {
                if (params['action'] != undefined && params['action'] == 'reset') {
                    if (params['reset_key'] != undefined && params['reset_key']) {
                        this_h.reset_key = params['reset_key'];
                        // this_h.pageLogin = 'reset';
                        setTimeout(function () {
                            this_h.eventFire(document.getElementById('popup-login'), 'click');
                        }, 1000);
                    }
                }
            });

        this.getMenu();
        this.getMeetingMenu();
    }


    logout() {
        this.authService.logout();
    }

    openLogin() {
        this.modalService.open(LoginComponent, {size: "sm"});
    }

    openSignup() {
        this.modalService.open(SignupComponent, {size: "sm"});
    }

    getMenu() {
        this.http.get(Conf.API_URL + '/get-menu-data/').subscribe(
            data => {
                this.menu = data['results'];
                // console.log(this.menu)
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getMeetingMenu() {
        this.http.get(Conf.API_URL + '/get-meeting-menu-data/').subscribe(
            data => {
                this.meeting_menu = data['results'];
                // console.log(this.menu)
            },
            error => {
                console.log(error.error)
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/header/header.component.ts